import { Koi } from '@ksyos/koi';
import type { Section } from '@common/formEngine/formEngine.types';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { NullablePrimitives } from '@common/utils/utilityTypes';

export type BariPostSurgeryDateData = NullablePrimitives<{
    datum_operatie: string | Date;
}>;

export type BariPostSurgeryDateKey = DeepPickPath<BariPostSurgeryDateData>;

export const bariPostSurgeryDateSections: Section<BariPostSurgeryDateData>[] = [
    {
        fields: [
            {
                draftSchema: Koi.koi().date().allow(null),
                finalSchema: Koi.koi().date(),
                isRequired: true,
                key: 'datum_operatie',
                label: 'OK datum',
                type: 'dateInput',
            },
        ],
    },
];
